import {
  Popover,
  PopoverPlacement,
  Tooltip,
  TooltipPlacement,
} from 'farmhub-ui-core';

import { Wrapper } from './styles';

interface IconWrapperProps {
  disabled?: boolean;
  displayBackground?: boolean;
  icon: JSX.Element;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  background?: string;
  styles?: any;
  hoverBackground?: string;
  hoverColorIcon?: string;
  tooltip?: string;
  popover?: JSX.Element;
  containerId?: string;
  onClick?: (e: any) => void;
}

const IconWrapper = ({
  disabled,
  icon,
  size = 'md',
  background,
  styles,
  hoverBackground,
  hoverColorIcon,
  displayBackground,
  tooltip,
  popover,
  containerId,
  onClick,
}: IconWrapperProps): JSX.Element => {
  const handleClick = (e: any) => {
    e.stopPropagation();
    !disabled && onClick && onClick(e);
  };
  return (
    <>
      {!tooltip && !popover && (
        <Wrapper
          background={background}
          disabled={disabled}
          displayBackground={displayBackground}
          hoverBackground={hoverBackground}
          hoverColorIcon={hoverColorIcon}
          size={size}
          styles={styles}
          onClick={handleClick}
        >
          {icon}
        </Wrapper>
      )}
      {tooltip && (
        <Tooltip placement={TooltipPlacement.Top} title={tooltip}>
          <Wrapper
            background={background}
            disabled={disabled}
            displayBackground={displayBackground}
            hoverBackground={hoverBackground}
            hoverColorIcon={hoverColorIcon}
            size={size}
            styles={styles}
            onClick={handleClick}
          >
            {icon}
          </Wrapper>
        </Tooltip>
      )}
      {popover && (
        <Popover
          containerId={containerId || 'content'}
          content={popover}
          mouseEnterDelay={1}
          placement={PopoverPlacement.LeftTop}
        >
          <Wrapper
            background={background}
            disabled={disabled}
            displayBackground={displayBackground}
            hoverBackground={hoverBackground}
            hoverColorIcon={hoverColorIcon}
            size={size}
            styles={styles}
            onClick={handleClick}
          >
            {icon}
          </Wrapper>
        </Popover>
      )}
    </>
  );
};

export default IconWrapper;
